import React, { useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useTranslation } from "react-i18next";

const FAQ = () => {
  // Manage the expanded state for each tab
  const [activeIndex, setActiveIndex] = useState(null);

  const { t } = useTranslation("home");

  // Toggle the active state
  const toggleTab = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className="flex lg-small:flex-col justify-between mt-16 px-20 sm-max:px-8 lg-small:gap-10 pb-10" >
      <div className="sm:lg-small:text-center sm-max:text-left" id="faq" >
        <h1 className="text-4xl font-medium sm-max:text-center">{t("faq.title")}</h1>
      </div>
      <div className="w-1/2 lg-small:w-full">
        <Accordion
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          className="flex flex-col gap-4"
        >
          {t("faq.cards", { returnObjects: true }).map((item, index) => (
            <AccordionTab
              key={index}
              className={`[&>a>svg]:hidden [&>a]:rounded-t-lg [&>a]:border-t [&>div]:rounded-b-lg [&>a]:border-x [&>div]:border-x [&>div]:border-b [&>*]:border-blue-400 [&>a]:py-4 [&>div]:pt-0 ${
                activeIndex !== index ? "[&>a]:rounded-b-lg [&>a]:border-b" : ""
              }`}
              header={
                <div className="flex items-center w-full ">
                  <span className="font-medium text-lg white-space-nowrap text-[#1B428E]">
                    {item.question}
                  </span>
                  <span className="flex-1" />
                  <button
                    className="text-lg font-bold"
                    onClick={(e) => {
                      // e.stopPropagation();
                      toggleTab(index);
                    }}
                  >
                    {activeIndex === index ? "−" : "+"}
                  </button>
                </div>
              }
            >
              <div className="bg-blue-500 absolute top-0 left-0 w-full h-full z-10 opacity-50"></div>
              <p className="m-0 text-[#3A61A5] pt-5">{item?.answer}</p>
            </AccordionTab>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default FAQ;
